import { ordersListService } from '@modules/showroom/basketAndOrders/service/OrdersListService'

export class WsOrderManagementDataStore {
  updateOrderStatus = async (orderIds, status, clientId?) => {
    try {
      const response = await ordersListService.updateOrderStatus(
        orderIds,
        status,
        clientId
      )
      if (response) {
        return response
      }
    } catch (e) {
      throw e
    }
  }

  getEmptyClientOrders = async orderIds => {
    const response: any = await ordersListService.getEmptyClientOrders(orderIds)
    if (response?.data) {
      return response.data?.emptyOrderNumbers
    }
  }

  getEmptyDoorOrders = async orderIds => {
    const response: any = await ordersListService.getEmptyDoorOrders(orderIds)
    if (response?.data) {
      return response.data?.emptyOrderNumbers
    }
  }
}

export const wsOrderManagementDataStore = new WsOrderManagementDataStore()
